import React, {Fragment, useRef, useEffect} from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {Helmet, HelmetProvider} from 'react-helmet-async';
import {BrowserRouter, Switch, Route, matchPath} from 'react-router-dom';
import {ThemeProvider} from 'styled-components';
import commonHelmetJson from '../../src/utils/common-helmet.json';
import createStore from '../../src/create-redux-store';
import {Header} from '@growth/dweb-header';
import Footer from '../../src/core-components/Footer/footer';
import Modal from '../../src/core-components/Modal/modal';
import {defaultTheme} from '../../src/utils/build-theme/build-theme';
import {GlobalStyles} from '../../src/utils/global-style';
import { loadableReady } from '@loadable/component';
import { init as initApm } from '@elastic/apm-rum'

// Common user widget integeration
// Ping did mount integeration
// Component did catch error tracking
// Modal support
//import * as Sentry from "@sentry/react";
// import { BrowserTracing } from "@sentry/tracing";


const App = ({routes, store, theme, style}) => {
  let hideHeader = false;
  let hideFooter = false;
  let showModal = false;
  let sticky = false;
  const RouteComponent = props => {
    const {location} = props;
    const {pathname} = location;
    const previousLocationRef = useRef<typeof location | undefined>(undefined);
    useEffect(() => {
      previousLocationRef.current = location;
    });

    const previousLocation = previousLocationRef.current;
    routes.some(route => {
      const matchObj = matchPath(pathname, route);
      if (matchObj) {
        const {showHeader = true, showFooter = true, isModal = false, stickyHeader = false} = route;
        hideHeader = !showHeader;
        hideFooter = !showFooter;
        showModal = isModal;
        sticky = stickyHeader;
      }
      return matchObj;
    });

    return (
      <Fragment>
        {(!hideHeader && 
          <Header 
            location={window.location} 
            sticky={sticky}
            lobName="cabs"
            onLoginSuccess={() => window.location.reload()}
            onLogoutSuccess={() => window.location.reload()}
           />) || null}
        {(showModal && (
          <Modal>
            <Switch>
              {routes
                .filter(route => route.isModal)
                .map(route => (
                  <Route {...route} />
                ))}
            </Switch>
          </Modal>
        )) ||
          null}
        <Switch location={showModal ? previousLocation : location}>
          {routes
            .filter(route => !route.isModal)
            .map(route => (
              <Route {...route} />
            ))}
        </Switch>
        {(!hideFooter && <Footer />) || null}
      </Fragment>
    );
  };

  let styleComponent = <GlobalStyles />;
  if (style) {
    styleComponent = style;
  }
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <Helmet {...commonHelmetJson} />
        <Provider store={store}>
          {styleComponent}
          <BrowserRouter>
            <Route component={RouteComponent} />
          </BrowserRouter>
        </Provider>
      </ThemeProvider>
    </HelmetProvider>
  );
};

export default function mountReactApp({
  routes,
  reducers,
  initialState = (window as any).__initial_state__,
  theme,
  style,
}) {
  console.log("[client] mountReactApp start", { path: window.location.pathname, search: window.location.search });
  const store = createStore({reducers, initialState});
  const urlPath = window.location.pathname;
  const searchString = window.location.search;
  const baseUrl = window.location.origin;
  routes.some(route => {
    const matchObj = matchPath(urlPath, route);
    if (matchObj) {
      console.log("[client] matched route for hydrate", { key: route.key, path: route.path });
      const {params = {}} = matchObj;
      const {populateStoreFromUrl = () => {}} = route;
      populateStoreFromUrl({params, searchString, baseUrl}, store.dispatch);
    }
    return matchObj;
  });
  
  initApm({
    serviceName: 'Cabs-GoCars-Frontend',
    serverUrl: process.env.BUILD_ENV === "prod" ? 'https://cabs-apm.makemytrip.com' : 'http://172.16.217.90:8200',
    environment: process.env.BUILD_ENV === "prod" ? 'production' : 'staging'
  })
  
  loadableReady(() => {
    console.log("[client] loadableReady - hydrating React into #root");
    ReactDOM.hydrate(
      <App routes={routes} store={store} theme={theme || defaultTheme} style={style} />,
      document.getElementById('root'),
    );
  })
  // window.pageSeen('TTI');
};

